// extracted by mini-css-extract-plugin
export default {"cont":"PageNotFound_cont__LXhgw"};